export const termsSections = [
  {
    title: '1. Acceptance of these Terms',
    paragraphs: [
      'These Terms of Service govern your access to and use of the Paddle Up website, mobile application, software, content, products, and related services. By accessing or using Paddle Up, you confirm that you have read, understood, and agree to these Terms and our Privacy Policy.',
      'If you use Paddle Up on behalf of an organization, you represent that you have authority to bind that organization to these Terms. If you do not agree to these Terms, you must not access or use the service.',
    ],
  },
  {
    title: '2. Eligibility',
    paragraphs: [
      'You must be legally capable of entering into a binding agreement in your jurisdiction to use Paddle Up. If you are under the age of majority where you live, you may use the service only with the consent and supervision of a parent or legal guardian.',
      'The service is not intended for children under 13. A parent or guardian who permits a minor to use Paddle Up is responsible for the minor\'s activity and compliance with these Terms.',
    ],
  },
  {
    title: '3. The Paddle Up Service',
    paragraphs: [
      'Paddle Up provides technology-supported pickleball coaching features, which may include video analysis, computer vision, performance insights, training recommendations, statistics, and educational content. Available features may vary by device, region, subscription, and product version.',
      'We may improve, update, limit, suspend, or discontinue any part of the service. We do not guarantee that a particular feature will always be available or that the service will be uninterrupted or error-free.',
    ],
  },
  {
    title: '4. Accounts and Account Security',
    paragraphs: [
      'Some features may require an account. You agree to provide accurate and current information, maintain the confidentiality of your credentials, and promptly update information that changes. You are responsible for activity conducted through your account.',
      'You must promptly notify us if you believe your account has been accessed without authorization. We may suspend or restrict an account when reasonably necessary to protect users, the service, or Paddle Up.',
    ],
  },
  {
    title: '5. Subscriptions, Billing, and Trials',
    paragraphs: [
      'Paid features may be offered through recurring subscriptions or one-time purchases. Prices, billing intervals, included features, and applicable taxes will be disclosed before purchase. Purchases made through an app marketplace are also governed by that marketplace\'s terms.',
      'Unless otherwise stated, subscriptions renew automatically until canceled. You may cancel through the purchasing platform before the renewal date. Cancellation stops future renewal charges but does not ordinarily provide a refund for the current billing period, except where required by law.',
      'Promotional trials may convert to paid subscriptions unless canceled before the trial ends. We may change pricing prospectively after providing notice required by applicable law.',
    ],
  },
  {
    title: '6. User Content and Permissions',
    paragraphs: [
      'You retain ownership of videos, images, comments, profile information, and other materials you submit to Paddle Up. You represent that you have all rights and permissions needed to upload and process that content, including permission from individuals who appear in it.',
      'You grant Paddle Up a limited, worldwide, non-exclusive license to host, store, reproduce, process, display, and transmit your content only as necessary to operate, secure, maintain, and improve the service. This license ends when the content is deleted, subject to reasonable backup retention and legal obligations.',
    ],
  },
  {
    title: '7. Acceptable Use',
    paragraphs: [
      'You may not misuse Paddle Up. Prohibited conduct includes violating applicable law; infringing intellectual property or privacy rights; uploading unlawful, harmful, deceptive, or malicious material; attempting unauthorized access; interfering with service operation; reverse engineering except where legally permitted; scraping the service; or using automated systems in a way that creates an unreasonable burden.',
      'You may not use analysis or recommendations from Paddle Up to harass, discriminate against, monitor, or make high-impact decisions about another person.',
    ],
  },
  {
    title: '8. Coaching, Health, and Safety Disclaimer',
    paragraphs: [
      'Paddle Up provides general informational and educational content, not medical advice, diagnosis, physical therapy, or professional sports instruction. Automated analysis may be incomplete, inaccurate, or unsuitable for your circumstances.',
      'Pickleball and physical training involve risk of injury. Consult a qualified healthcare professional before beginning a new exercise program, especially if you have an injury or medical condition. Stop activity and seek appropriate care if you experience pain, dizziness, or other concerning symptoms.',
    ],
  },
  {
    title: '9. Intellectual Property',
    paragraphs: [
      'The service, including its software, visual design, branding, models, text, graphics, and other materials supplied by Paddle Up, is owned by Paddle Up or its licensors and protected by intellectual property laws.',
      'Subject to these Terms, we grant you a limited, personal, revocable, non-transferable, and non-exclusive right to use the service for its intended purpose. No other rights are granted by implication.',
    ],
  },
  {
    title: '10. Third-Party Services',
    paragraphs: [
      'Paddle Up may link to or interoperate with third-party platforms, app stores, devices, or services. We do not control those services and are not responsible for their availability, security, content, or practices. Your use of them is governed by their separate terms and policies.',
    ],
  },
  {
    title: '11. Suspension and Termination',
    paragraphs: [
      'You may stop using Paddle Up at any time. We may suspend or terminate access if you materially violate these Terms, create risk or legal exposure, fail to pay applicable fees, or misuse the service.',
      'Following termination, provisions that by their nature should survive will remain effective, including provisions concerning ownership, disclaimers, limitations of liability, and dispute resolution.',
    ],
  },
  {
    title: '12. Disclaimers',
    paragraphs: [
      'To the maximum extent permitted by law, Paddle Up is provided "as is" and "as available." We disclaim all express and implied warranties, including merchantability, fitness for a particular purpose, title, non-infringement, accuracy, and uninterrupted availability.',
      'We do not warrant that automated coaching results will be accurate, that use of the service will improve athletic performance, or that the service will be compatible with every device or recording environment.',
    ],
  },
  {
    title: '13. Limitation of Liability',
    paragraphs: [
      'To the maximum extent permitted by law, Paddle Up and its affiliates, officers, employees, agents, and licensors will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages, or for lost profits, data, goodwill, or opportunities arising from or related to the service.',
      'Where liability cannot be excluded, our aggregate liability will not exceed the greater of the amount you paid to Paddle Up during the 12 months before the event giving rise to the claim or 100 US dollars. Some jurisdictions do not permit certain limitations, so portions of this section may not apply to you.',
    ],
  },
  {
    title: '14. Governing Law and Disputes',
    paragraphs: [
      'These Terms and any dispute arising from or relating to Paddle Up are governed by the laws of the State of Alabama, without regard to its conflict-of-law rules. Subject to applicable consumer protection law, state and federal courts located in Alabama will have exclusive jurisdiction over such disputes.',
      'Before filing a formal claim, you agree to contact us and attempt to resolve the issue informally. Nothing in these Terms limits rights or remedies that cannot lawfully be waived under Alabama or applicable federal law.',
    ],
  },
  {
    title: '15. Changes to these Terms',
    paragraphs: [
      'We may revise these Terms as the service evolves. If a change materially affects your rights, we will provide reasonable notice through the service or another appropriate channel. Continued use after the effective date constitutes acceptance of the revised Terms.',
    ],
  },
  {
    title: '16. General Terms and Contact',
    paragraphs: [
      'If any provision is found unenforceable, the remaining provisions remain effective. Our failure to enforce a provision is not a waiver. You may not transfer these Terms without our consent; we may transfer them as part of a merger, acquisition, reorganization, or sale of assets.',
      'Questions about these Terms may be sent to paddleupcoach@gmail.com.',
    ],
  },
];

export const privacySections = [
  {
    title: '1. Overview',
    paragraphs: [
      'Paddle Up is a pickleball coaching app that uses AI to analyze your shots and help you improve. You do not create an account with us. This Privacy Policy explains what information we collect, why we collect it, how we use it, who we share it with, and your choices.',
      'By using Paddle Up, you agree to the practices described in this policy. If you do not agree, please do not use the app.',
    ],
  },
  {
    title: '2. What We Collect',
    paragraphs: [
      'We collect the following types of information when you use Paddle Up:',
      '• Videos and images you upload so our AI can analyze your shots and provide coaching feedback',
      '• Quiz answers, drill progress, streaks, and similar coaching data to personalize your experience',
      '• An anonymous app user ID to identify your device and sync your progress',
      '• Purchase and subscription status from Apple to unlock Premium features',
      '• Basic app usage information, such as which screens you open and which features you use',
      '• Crash information and diagnostics if our tools record an error, to help us fix bugs and improve stability',
    ],
  },
  {
    title: '3. What We Do Not Collect',
    paragraphs: [
      'We do not collect your name, email address, or phone number in the app.',
      'We do not use your data for advertising or targeted ads.',
      'We do not sell your data to third parties.',
      'We do not show your videos to other users or make them publicly visible.',
    ],
  },
  {
    title: '4. How We Use Your Information',
    paragraphs: [
      'We use the information we collect to:',
      '• Analyze your shots using AI and provide personalized coaching feedback',
      '• Personalize drills, lessons, and training recommendations based on your progress',
      '• Unlock Premium features after you complete a purchase',
      '• Keep the app working reliably and securely',
      '• Understand which features are used or fail, so we can improve the app',
      '• Respond to support requests and investigate technical issues',
    ],
  },
  {
    title: '5. Who We Share Information With',
    paragraphs: [
      'We share information with the following service providers who help us operate Paddle Up:',
      '• Apple — processes subscription billing and provides purchase status',
      '• RevenueCat — manages subscription status using an anonymous ID and purchase receipt',
      '• Hosting and AI providers — store coaching data and analyze uploaded video clips',
      'These providers are contractually required to use your information only for the purposes we specify and to protect it appropriately. We do not sell your personal information to anyone.',
    ],
  },
  {
    title: '6. Payments and Subscriptions',
    paragraphs: [
      'Apple processes all payments for subscriptions purchased through the iOS app. We never see your credit card number or full payment details. We only receive confirmation of your subscription status (active, expired, or canceled) so we can unlock Premium features.',
      'Your payment information is governed by Apple\'s privacy policy. You can manage or cancel your subscription in your Apple Account settings.',
    ],
  },
  {
    title: '7. How Long We Keep Your Information',
    paragraphs: [
      'We keep videos, coaching data, and progress information only as long as needed to provide the features you use and support the app. If you stop using Paddle Up, your data may be deleted after a period of inactivity.',
      'You can email us at paddleupcoach@gmail.com to request deletion of your stored coaching data. We will delete or anonymize your information unless we are required to keep it for legal, security, or fraud-prevention reasons.',
    ],
  },
  {
    title: '8. Your Choices and Rights',
    paragraphs: [
      'You can control some of your information:',
      '• Stop uploading videos at any time',
      '• Delete the app to stop all data collection',
      '• Email us to request deletion of stored coaching data',
      '• Manage or cancel your subscription in your Apple Account settings',
      'Depending on your location, you may have additional rights under privacy laws, such as the right to access, correct, or delete your personal information. Contact us at paddleupcoach@gmail.com to exercise these rights.',
    ],
  },
  {
    title: '9. Artificial Intelligence and Automated Analysis',
    paragraphs: [
      'Paddle Up uses computer vision and machine-learning technology to analyze your pickleball videos and generate coaching observations. This automated analysis may be inaccurate and should be treated as general educational information, not professional coaching, medical advice, or a guarantee of performance improvement.',
      'We process your videos only to provide coaching features. We do not use video analysis to identify you through facial recognition or to make legally significant decisions about you, such as employment, credit, or insurance eligibility.',
    ],
  },
  {
    title: '10. Security',
    paragraphs: [
      'We use technical and organizational safeguards to protect your information, including encryption, access controls, and secure storage. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.',
      'If we become aware of a security breach that affects your information, we will notify you as required by law.',
    ],
  },
  {
    title: '11. Children\'s Privacy',
    paragraphs: [
      'Paddle Up is not directed at children under 13, and we do not knowingly collect personal information from children under 13. If you believe a child has provided information to us, please contact us at paddleupcoach@gmail.com so we can investigate and delete it.',
    ],
  },
  {
    title: '12. International Data Transfers',
    paragraphs: [
      'Paddle Up and its service providers may process information in countries other than where you live. Where required by law, we use recognized safeguards for international data transfers, such as approved contractual protections.',
    ],
  },
  {
    title: '13. App Store Privacy Disclosures',
    paragraphs: [
      'The privacy information shown on Paddle Up\'s Apple App Store product page summarizes the data practices described in this policy. Data associated with you may include purchase status, user-provided videos or images, coaching progress, device information, diagnostics, and crash data.',
      'We use this information for app functionality, subscription access, coaching personalization, security, performance monitoring, and product improvement. We do not use personal information for cross-app tracking and do not sell personal information.',
      'Apple may independently process purchase, device, diagnostic, and App Store activity information under Apple\'s privacy policy.',
    ],
  },
  {
    title: '14. Tracking, Advertising, and Analytics',
    paragraphs: [
      'Paddle Up does not track you across apps or websites for targeted advertising. We do not access Apple\'s advertising identifier unless required by a feature and permitted by law.',
      'We use analytics to understand feature usage, investigate crashes, and improve performance. Service providers handling this information are limited to the purposes described in this policy and cannot use it for their own advertising.',
    ],
  },
  {
    title: '15. Alabama Privacy and Governing Law',
    paragraphs: [
      'Paddle Up is operated subject to the laws of the State of Alabama and applicable federal privacy laws. Alabama residents may contact us to ask questions about personal information, request access or correction, or report concerns about our privacy practices.',
      'We handle security incidents and breach notifications in accordance with the Alabama Data Breach Notification Act and other applicable laws. This section does not limit privacy rights available under the laws of another jurisdiction.',
    ],
  },
  {
    title: '16. Changes to This Policy',
    paragraphs: [
      'We may update this Privacy Policy from time to time. If we make material changes, we will notify you by updating the "Last updated" date at the top of this policy and, where appropriate, providing additional notice through the app or by email.',
      'Continued use of Paddle Up after the effective date of the updated policy constitutes acceptance of the changes.',
    ],
  },
  {
    title: '17. Contact Us',
    paragraphs: [
      'To ask a privacy question, submit a privacy rights request, request data deletion, or contact support, email paddleupcoach@gmail.com.',
      'Please do not send passwords, payment information, or other highly sensitive information through unencrypted email. We may provide a more secure method when additional information is needed.',
    ],
  },
];